import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

// Register necessary components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const CircleChartWithCartoonStyleAndLabels = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const createChartData = (value) => {
    const is99 = value === 99;
    const is1 = value === 10;
    return {
      datasets: [
        {
          data: [value, 100 - value], // Progress and empty space
          backgroundColor: [is99 ? 'black' : 'white', is1 && 'black'], // Dynamically set inner and outer colors
          borderWidth: 8, // Thicker border for cartoonish effect
          borderColor: is99 ? 'white' || is1 : 'transparent', // Dynamically set border color
          cutout: '70%', // Inner cutout to create a circular appearance
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { enabled: false }, // Disable tooltips
      legend: { display: false }, // Disable legend
      beforeDraw: (chart) => {
        const { width } = chart;
        const { ctx } = chart;
        const value = chart.config.data.datasets[0].data[0]; // Progress value
        ctx.restore();
        const fontSize = (width / 7).toFixed(2); // Bigger font for cartoon look
        ctx.font = `${fontSize}px 'Comic Sans MS', sans-serif`; // Cartoon font
        ctx.textBaseline = 'middle';

        const text = `${value}%`;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = width / 2;

        ctx.fillStyle = value === 99 ? '#000' : '#fff'; // Dynamically set text color based on value
        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    },
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: `${matches ? 'wrap-reverse' : 'no-wrap'}`,
        alignItems: 'center',
        gap: `${matches ? '20px' : 4}`,
      }}
    >
      {/* 1% Progress */}
      <div style={{ width: '100px', height: '100px', position: 'relative' }}>
        <Doughnut data={createChartData(10)} options={chartOptions} />
        <div
          style={{
            textAlign: 'center',
            fontSize: '16px',
            fontFamily: 'Chewy',
            color: 'black', // Text color for 1%
          }}
        >
          1% Team
        </div>
      </div>

      {/* 99% Progress */}
      <div style={{ width: '200px', height: '200px', position: 'relative' }}>
        <Doughnut data={createChartData(90)} options={chartOptions} />
        <div
          style={{
            textAlign: 'center',
            fontSize: '16px',
            fontFamily: 'Chewy',
            color: 'black', // Text color for 99%
          }}
        >
          99% Yours
        </div>
      </div>
    </div>
  );
};

export default CircleChartWithCartoonStyleAndLabels;
